// extracted by mini-css-extract-plugin
export default {"content":"Menu-module__content__u-i5-","menu":"Menu-module__menu__h0WZd"};